import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.66666 10C1.66666 6.07165 1.66666 4.10746 2.88704 2.88708C4.10743 1.66669 6.07162 1.66669 9.99999 1.66669C13.9284 1.66669 15.8925 1.66669 17.1129 2.88708C18.3333 4.10746 18.3333 6.07165 18.3333 10C18.3333 13.9284 18.3333 15.8926 17.1129 17.113C15.8925 18.3334 13.9284 18.3334 9.99999 18.3334C6.07162 18.3334 4.10743 18.3334 2.88704 17.113C1.66666 15.8926 1.66666 13.9284 1.66666 10Z",
  stroke: "#4B4B4B",
  "stroke-width": "1.25"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.83334 15L5.83334 12.5",
  stroke: "#4B4B4B",
  "stroke-width": "1.25",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 15V10",
  stroke: "#4B4B4B",
  "stroke-width": "1.25",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.1667 15V7.5",
  stroke: "#4B4B4B",
  "stroke-width": "1.25",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}